<ng-container *transloco="let t">
  <mat-card class="margin-xs-bottom">
    <mat-card-header>
      <mat-card-title>{{ t('views.psa.inventory_declaration.articles') }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (isAdminReview) {
        <form [formGroup]="form" class="inventory-review-list">
          @for (article of metadata.articles; track article.baseItemId) {
            <div class="inventory-review-item">
              <div class="inventory-review-item__title">{{ article.title }}</div>
              <div class="inventory-review-item__meta">
                {{ t('views.psa.inventory_declaration.max') }}: {{ article.maxCount }} |
                {{ t('views.psa.inventory_declaration.reported') }}: {{ article.declaredCount }} |
                {{ t('views.psa.inventory_declaration.system_owned') }}: {{ article.systemOwned }}
              </div>
              <mat-radio-group [formControlName]="`decision_${article.baseItemId}`" class="inventory-review-item__decision">
                <mat-radio-button value="accepted">{{ t('views.psa.inventory_declaration.accept') }}</mat-radio-button>
                <mat-radio-button value="rejected">{{ t('views.psa.inventory_declaration.reject') }}</mat-radio-button>
              </mat-radio-group>
              @if (getDecision(article.baseItemId) === 'rejected') {
                <mat-form-field appearance="outline" class="inventory-review-item__reason">
                  <mat-label>{{ t('views.psa.inventory_declaration.rejection_reason') }}</mat-label>
                  <textarea matInput rows="2" [formControlName]="`reason_${article.baseItemId}`"></textarea>
                </mat-form-field>
              }
            </div>
          }
        </form>
        <div class="inventory-review-actions">
          <button mat-raised-button color="primary" type="button" [disabled]="submitting" (click)="submit()">
            {{ t('general.confirm') }}
          </button>
        </div>
      } @else {
        <div class="inventory-review-list">
          @for (article of metadata.articles; track article.baseItemId) {
            @let decision = getResolvedDecision(article.baseItemId);
            <div class="inventory-review-item">
              <div class="inventory-review-item__title">{{ article.title }}</div>
              <div class="inventory-review-item__meta">
                {{ t('views.psa.inventory_declaration.reported') }}: {{ article.declaredCount }} /
                {{ article.maxCount }}
              </div>
              @if (decision?.accepted) {
                <div class="inventory-review-item__status accepted">
                  <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                  {{ t('views.psa.inventory_declaration.accepted') }}
                </div>
              } @else if (decision) {
                <div class="inventory-review-item__status rejected">
                  <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                  {{ t('views.psa.inventory_declaration.rejected') }}: {{ decision.rejectionReason }}
                </div>
              }
            </div>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>
</ng-container>
